import { useMemo } from 'react'
import { useBusinessIdPathParam } from 'lib/navigation/hooks/useBusinessIdPathParam/useBusinessIdPathParam'
import { getBusinessTraits } from 'lib/helpers/getBusinessTraits/getBusinessTraits'
import { useGatedQuery } from 'lib/hooks/useGatedQuery/useGatedQuery'
import { BusinessTraitsHook_businessDocument } from './useBusinessTraits.graphql'

export const useBusinessTraits = () => {
  const businessId = useBusinessIdPathParam()
  const { data: { business = null } = {} } = useGatedQuery(BusinessTraitsHook_businessDocument, businessId, {
    fetchPolicy: 'cache-and-network',
    variables: { businessId },
  })

  return useMemo(() => (business ? getBusinessTraits(business) : null), [business])
}
